import styled, { keyframes } from "styled-components";

// --- Animações ---
const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideInUp = keyframes`from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; }`;

// --- Componentes de Estilo ---
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: ${fadeIn} 0.3s ease-out;
  padding: 1rem;
`;

export const ModalContainer = styled.div`
  background: #202020;
  color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.6);
  width: 100%;
  max-width: ${(props) => (props.size === "medium" ? "750px" : "600px")};
  animation: ${slideInUp} 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  padding: 1.5rem 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    margin: 0;
    font-size: 1.6rem;
    font-weight: 600;
    color: #e6aa3a;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #888;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    color: #fff;
    transform: rotate(90deg);
  }
`;

export const ModalBody = styled.div`
  padding: 2rem;
  overflow-y: auto;
`;

export const ModalFooter = styled.div`
  padding: 1.5rem 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  background-color: #1a1a1a;
  margin-top: auto;
`;

const BaseButton = styled.button`
  padding: 12px 30px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
`;

export const CancelButton = styled(BaseButton)`
  background: transparent;
  color: #ccc;
  &:hover {
    background: #333;
  }
`;

export const SaveButton = styled(BaseButton)`
  background-color: #e6aa3a;
  color: #111;
  &:hover {
    background-color: #ffc241;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(230, 170, 58, 0.3);
  }
`;

export const InputGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  &.full-width {
    grid-column: 1 / -1;
  }

  label {
    color: #ccc;
    font-weight: 500;
    font-size: 0.9rem;
  }

  .input-wrapper {
    position: relative;
    display: flex;
    align-items: center;

    svg {
      position: absolute;
      left: 15px;
      color: #666;
    }
  }

  input {
    width: 100%;
    height: 50px;
    background: #2c2c2c;
    border: 1px solid #444;
    color: #fff;
    padding: 0 15px 0 45px;
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.3s;

    &:focus {
      outline: none;
      border-color: #e6aa3a;
      box-shadow: 0 0 0 3px rgba(230, 170, 58, 0.25);
    }
  }
`;
